export default {
  payWelfareText: 'Benefici Ricarica',
  blackFridayDiscount: 'Sconto a Tempo Black Friday',
  shareGift: 'Condividi Regalo',
  vipWeeklyWelfare: 'Sconto Settimanale VIP',
  exchangeCoupon: 'Buono',
  firstPayOff: 'Fino al 15% di SCONTO per il Primo Acquisto',
  blackFridayEvent: 'Evento Black Friday',
  limitedTimeOff: 'Sconto del 10% per un Periodo Limitato',
  claimCoupon: 'Rivendica Ora',
  blackFridayTimedCoupon: 'Buono a Tempo Black Friday',
  timeLeft: 'Tempo restante:',
  claimTimeCoupon: 'Rivendica Buono 10% SCONTO Ora!',
  points: 'Punti: ${point}',
  costPointTip: 'Scambia punti per buoni',
  maxPointTip: 'Ogni account può usare fino a 500 punti.',
  discountOff: '10% SCONTO',
  highestDiscount: 'Fino a ${discount} SCONTATI',
  needPoint: 'Richiede ${point} pti',
  changeCurrency: 'Cambia Valuta',
  claim: 'Rivendica',
  claimSucc: 'Rivendicato',
  claimFail: 'Fallito',
  pointNotEnough: 'Pti insufficienti',
  afterClaimPoint: 'Punti rimanenti: ${point}',
  footTips1: 'È possibile utilizzare solo 1 buono per ogni ordine.',
  footTips2:
    'Il buono non può essere utilizzato per acquistare valute/gettoni di gioco.',
  footTips3:
    "Ci riserviamo il diritto per l'interpretazione finale di questo evento.",
  ruleTitleText: 'Regole Evento',
  ruleTime:
    "Durata dell'Evento: 00:00 del 24 Nov. 2023 alle 23:59 del 26 Nov. 2023 (UTC)",
  bfRuleText1:
    "1. 400 punti verranno assegnati al tuo account quando accedi per la prima volta alla pagina di ricarica ufficiale durante l'evento. Puoi scambiare fino a 500 punti con buoni.",
  bfRuleText2:
    "2. Puoi scambiare i punti del Black Friday con i buoni durante l'evento.",
  bfRuleText3:
    '3. Puoi utilizzare solo 1 buono per ogni ordine. I buoni non possono essere utilizzati per acquistare valute/gettoni di gioco.',
  bfRuleText4: '4. Per le transazioni accettiamo solo le seguenti valute:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. Non è possibile cambiare la valuta una volta effettuata la transazione. I punti scambiati non possono essere rimborsati.',
  bfRuleText6: '6. I buoni del Black Friday saranno validi solo per 7 giorni.',
  bfRuleText7:
    "7. Ci riserviamo il diritto per l'interpretazione finale di questo evento.",
  thanksTip:
    "Grazie per la vostra partecipazione. Unisciti alla nostra community ufficiale per ulteriori informazioni sull'evento.",
  exchangePoints: 'Scambio',
  exchangeCode: 'Inserisci il codice di scambio.',
  enterExchangeCode: 'Inserisci il codice di scambio.',
  exchangeText: 'Scambio',
  confirmGet: 'Conferma',
  couponUsedWay:
    'Il buono può essere utilizzato solo con valute specifiche, conferma la tua valuta.',
  confirmText: 'Conferma',
  exchangeSucc: 'Scambiato',
  aboutCoins: 'Informazioni su Valute/Gettoni di gioco',
  aboutCoinsText:
    'Puoi scambiare valute/gettoni di gioco con tutti i pacchetti e privilegi ad eccezione della valuta/gettone di gioco stesso.',
  known: 'OK',
  codeText: 'Codice',
  codeInvalid: 'Codice invalido!',
  hasExchanged: 'Non puoi richiedere più codici.',
  hideText: 'Nascondi',
  //黑五的报错码
  'bf-20001': 'Accesso non effettuato',
  'bf-20002': "Errore di parametro. Prova a rientrare nell'evento.",
  'bf-20003': 'Pti insufficienti',
  'bf-20004': "Fallito! Riprova più tardi o contatta l'Assistenza Clienti.",
  'bf-20005': 'Rivendicato',
  'bf-20015': 'L’evento non è al momento disponibile',
  'bf-20016': 'L’evento è terminato.',
  bfShareText: 'Rivendica Buono 10% SCONTO Ora!',
  rightsCenterBtn: 'Centro Membro Premium',
  payBtn: 'Pagamento',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorioso Straordinario (Permanente)',
  rightCenterNoticeTitle: 'Il Sistema Punto VIP si Aggiorna al Centro Privilegi',
  rightCenterNoticeContent: 'Greetings, Commander!<br />Thank you for your supporting Puzzles & Survival. To bring you an even better rewards experience, the current VIP Point System will be upgraded to the all-new Premium Member Center on July 16, 2025. This new system will not only consolidate existing VIP benefits but also introduce a host of exciting new perks. Here\'s what you need to know:<br />1. What\'s Changing?<br />Weekly Log in Benefits Remain<br />From July 16 to 29, 2025, players can continue to claim Weekly VIP Coupons by logging in to the Official Top-up Page. The number of coupons will remain the same as in the VIP Point event. Meanwhile, players will also be able to redeem new coupons in the Premium Member Center, which will include a maximum discount cap. For more details on the new coupon rules and redemption limits, refer to the table at the end of this notice.<br />Note: The automatic coupon redemption feature must be manually enabled. To do so, go to: Privilege Center Homepage > Member Benefits > Enable Auto Redeem Coupons > Select Coupons to Auto-Redeem > Confirm.<br />New Points Exchange Feature<br />The Privilege Center will offer a Points Exchange feature. Earn points by logging in to the game or completing designated tasks. Points can be exchanged for exclusive coupons, rare items, and other valuable rewards. (See the Privilege Center page for item redemption limits.)<br />VIP Level Inheritance<br />Your current VIP level and accumulated VIP Points will be fully transferred to the new system. You\'ll automatically be assigned the corresponding Privilege Center tier, and all your current VIP benefits will be retained and further enhanced under the new system.<br />2. Why This Upgrade Is Better<br />Clearer Benefits: All reward rules and redemption details are clearly displayed, making it easier to claim your benefits.<br />Greater Rewards: Enjoy new point exchange events and regularly updated high-value items.<br />Lucky Draws: In addition to points exchange, prize draw events will also be available, giving you chances to win valuable in-game items.<br />3. Important Notes<br />During the transition period (July 16 to 29, 2025), the original VIP Points section will be gradually phased out. You will still be able to receive and use coupons as usual during this time. Be sure to use any remaining coupons before the VIP Points Event ends. Unused coupons will expire.<br />After the Privilege Center goes live, you can access it by going to Official Top-up Center > Tap Avatar > Privilege Center',
  rightCenterNoticeTableTitle: 'Confronto delle modifiche ai coupon',
  rightCenterNoticeTableHeader1: 'Requisiti per il Riscatto - Membro Livello Premium',
  rightCenterNoticeTableHeader2: 'Livello VIP originale',
  rightCenterNoticeTableHeader3: 'Sconto Buono',
  rightCenterNoticeTableHeader4: 'Limite di Acquisizione',
  rightCenterNoticeTableHeader5: 'Limite Sconto Massimo',
  rightCenterNoticeTableLevel1: 'Bronzo',
  rightCenterNoticeTableLevel2: 'Argento',
  rightCenterNoticeTableLevel3: 'Oro', 
  rightCenterNoticeTableLevel4: 'Platino',
  rightCenterNoticeTableLevel5: 'Diamante',
  rightCenterNoticeTableCount1: 'Una Volta al Giorno',
  rightCenterNoticeTableCount2: '15 Volte/Mese',
  rightCenterNoticeTableCount3: '10 Volte/Mese',
  rightCenterNoticeTableLimit: '$15',
  rightCenterNoticeTableTip: 'Nota: I massimali di sconto dei buoni nel Centro Privilegi si basano su USD e possono variare in base ai tassi di cambio. L\'importo effettivo dello sconto viene visualizzato nella pagina di utilizzo.',
  '-': '-'
};
